import axios from 'axios';
import store from '../../store';

const model = () => {
	return {
		id: 		null,
		deadline: 	'',
		message: 	'',
		user_id: 	null,
		completed:	null
	};
};

const readOpen = async (params) => {
	return (await axios.get('/todos/open')).data;
};

const save = async (model) => {
	try {
		return model.id ? await axios.put(`/todos/${model.id}`, model) : await axios.post(`/todos`, model);
	} catch (err) {
		return false;
	}
};

const read = async(id) => {
	return (await axios.get(`/todos/${id}`)).data;
};

const window = async (model, submit) => {
	store.dispatch('win/push', {
		component: 	'todo-window-view',
		model:		model,
		async submit(model) {
			return await submit(model);
		}
	});
};

const open = async (id, onSave) => {
	window(id ? await read(id) : model(), async (model) => {
		const r = await save(model);

		if (r) {
			if (onSave) onSave(r);
			return true;
		}

		return false;
	});
};

const del = async (id) => {
	await axios.delete(`/todos/${id}`);
};

const close = async (id) => {
	await axios.put(`/todos/${id}/close`);
};

export default {
	model,
	readOpen,
	save,
	read,
	open,
	window,
	del,
	close
};